// extracted by mini-css-extract-plugin
export default {"order__data":"OrderData_order__data__Qh4NH","order__list":"OrderData_order__list__LA1fT"};